/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Parse_ErrorInputs */

const en_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not parse resume. Please try again or use a different file.`)
};

const de_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf konnte nicht analysiert werden. Bitte versuch es erneut oder verwende eine andere Datei.`)
};

const fr_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'analyser le CV. Réessaie ou utiliser un autre fichier.`)
};

const es_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo analizar el currículum. Inténtelo de nuevo o use un archivo diferente.`)
};

const it_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile analizzare il curriculum. Riprova o usa un file diverso.`)
};

const nl_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon het CV niet verwerken. Probeer het opnieuw of gebruik een ander bestand.`)
};

const pl_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się przeanalizować CV. Spróbuj ponownie lub użyj innego pliku.`)
};

const fi_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluetteloa ei voitu jäsentää. Yritä uudelleen tai käytä eri tiedostoa.`)
};

const da_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke analysere CV. Prøv igen eller brug en anden fil.`)
};

const sv_resumes_parse_error = /** @type {(inputs: Resumes_Parse_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte tolka CV. Försök igen eller använd en annan fil.`)
};

/**
* | output |
* | --- |
* | "Could not parse resume. Please try again or use a different file." |
*
* @param {Resumes_Parse_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_parse_error = /** @type {((inputs?: Resumes_Parse_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Parse_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_parse_error(inputs)
	if (locale === "fr") return fr_resumes_parse_error(inputs)
	if (locale === "es") return es_resumes_parse_error(inputs)
	if (locale === "it") return it_resumes_parse_error(inputs)
	if (locale === "nl") return nl_resumes_parse_error(inputs)
	if (locale === "pl") return pl_resumes_parse_error(inputs)
	if (locale === "fi") return fi_resumes_parse_error(inputs)
	if (locale === "da") return da_resumes_parse_error(inputs)
	if (locale === "sv") return sv_resumes_parse_error(inputs)
	return en_resumes_parse_error(inputs)
});